/* global G */
import map from 'lib/sequence/model/api/map'
import find from 'lib/sequence/component/children/find'

/**
 * Map Attribute Hook
 *
 * Maps an attribute from the module's main model to the component with key `componentKey`.
 *
 * If no `componentKey` is passed, the model attribute gets mapped to the current action component.
 *
 * @param {string} attributeName  the name of the model's attribute to map
 * @param {string} [componentKey] the key of the component to map the attribute to
 * @returns {function(...[*]): *[]}
 */
const mapAttribute = (attributeName, componentKey) => obj => (...args) => {
  const model = obj[G.MODEL]
  const attribute = model[G.CHILDREN][attributeName]
  const actionComponent = obj[G.STATE][G.ACTION][G.COMPONENT]

  const targetComponent = componentKey
    ? find(actionComponent)[componentKey]
    : actionComponent

  map(attribute)(targetComponent)

  return args
}

export default mapAttribute
